const base = {
  transparent: 'transparent',
  white: '#FFFFFF',
  black: '#000000'
}

const brand = {
  primary: {
    50: '#FFFFFF',
    100: '#EDF0FF',
    200: '#C4CEFF',
    300: '#9CACFF',
    400: '#7389FF',
    500: '#4A67FF',
    600: '#1238FF',
    700: '#0023D9',
    800: '#001AA1',
    900: '#001169'
  },
  secondary: {
    50: '#FFEFF2',
    100: '#FFDAE2',
    200: '#FFB1C1',
    300: '#FF89A0',
    400: '#FF6080',
    500: '#FF375F',
    600: '#FE0033',
    700: '#C60028',
    800: '#8E001C',
    900: '#560011'
  },
  status: {
    success: '#34C759',
    warning: '#FFCC00',
    error: '#FF3B30'
  },
  'status-contrast': {
    success: '#248A3D',
    warning: '#B25000',
    error: '#D70015'
  }
}

export { base, brand }
